import { render, staticRenderFns } from "./FailedPurchase.vue?vue&type=template&id=0b6e188e"
import script from "./FailedPurchase.vue?vue&type=script&lang=js"
export * from "./FailedPurchase.vue?vue&type=script&lang=js"
import style0 from "./FailedPurchase.vue?vue&type=style&index=0&id=0b6e188e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports